// @generated by protobuf-ts 2.11.1 with parameter long_type_number,generate_dependencies
// @generated from protobuf file "common.proto" (package "common", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum common.ErrorCode
 */
export enum ErrorCode {
    /**
     * @generated from protobuf enum value: ErrorCodeUndefined = 0;
     */
    ErrorCodeUndefined = 0,
    /**
     * Login process
     *
     * @generated from protobuf enum value: ErrorCodeInvalidLoginCredentials = 1;
     */
    ErrorCodeInvalidLoginCredentials = 1,
    /**
     * @generated from protobuf enum value: ErrorCodeLoginMethodNotAllowed = 2;
     */
    ErrorCodeLoginMethodNotAllowed = 2,
    /**
     * Licensing
     *
     * @generated from protobuf enum value: ErrorCodeLicenseDeactivated = 3;
     */
    ErrorCodeLicenseDeactivated = 3,
    /**
     * @generated from protobuf enum value: ErrorCodeSSONotAllowed = 4;
     */
    ErrorCodeSSONotAllowed = 4,
    /**
     * User
     *
     * @generated from protobuf enum value: ErrorCodeUserNotFound = 5;
     */
    ErrorCodeUserNotFound = 5,
    /**
     * @generated from protobuf enum value: ErrorCodeLoggedInAnotherDevice = 6;
     */
    ErrorCodeLoggedInAnotherDevice = 6,
    /**
     * @generated from protobuf enum value: ErrorCodeCredentialsChanged = 7;
     */
    ErrorCodeCredentialsChanged = 7,
    /**
     * @generated from protobuf enum value: ErrorCodeUserDeleted = 8;
     */
    ErrorCodeUserDeleted = 8,
    /**
     * @generated from protobuf enum value: ErrorEmailLoginNotAllowed = 9;
     */
    ErrorEmailLoginNotAllowed = 9,
    /**
     * @generated from protobuf enum value: ErrorBasicLoginNotAllowed = 10;
     */
    ErrorBasicLoginNotAllowed = 10,
    /**
     * Booking
     *
     * @generated from protobuf enum value: ErrorCodeTimeSlotIsBusy = 11;
     */
    ErrorCodeTimeSlotIsBusy = 11,
    /**
     * @generated from protobuf enum value: ErrorCodeBookingOutsideWindow = 13;
     */
    ErrorCodeBookingOutsideWindow = 13,
    /**
     * @generated from protobuf enum value: ErrorSimultaneousReservationsForbidden = 14;
     */
    ErrorSimultaneousReservationsForbidden = 14,
    /**
     * Pairing
     *
     * @generated from protobuf enum value: ErrorCodePairingDeviceTypeMismatch = 15;
     */
    ErrorCodePairingDeviceTypeMismatch = 15,
    /**
     * Customer
     *
     * @generated from protobuf enum value: ErrorCodeCustomerWithDomainExists = 16;
     */
    ErrorCodeCustomerWithDomainExists = 16,
    /**
     * Generic
     *
     * @generated from protobuf enum value: ErrorCodeGeneric = 12;
     */
    ErrorCodeGeneric = 12
}
